// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header ion-title {
  text-align: center;
}

ion-content {
  --background: white;
}

.opps, .opps-brand {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 86%;
}

.opps-header h3 {
  margin: 20px 0;
  text-align: center;
  font-weight: 800;
  font-size: x-small;
  color: var(--ion-color-primary);
}

h2, h1 {
  font-weight: 600;
  text-align: center;
  font-size: 30px;
  color: black;
}

.opps-header {
  background: white;
  width: 90%;
}

.codigo {
  width: 90%;
  height: auto;
}

.iconos {
  display: block;
  justify-content: center;
  align-items: center;
  margin: auto;
  width: 90%;
  padding: 10px 0;
  text-align: center;
}

.img-logos {
  text-align: center;
  width: 30%;
  padding: 2px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/open-pay/open-pay.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAEF;;AAAA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+BAAA;AAGF;;AADA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AAIF;;AAFA;EAEE,iBAAA;EACA,UAAA;AAIF;;AAFA;EACE,UAAA;EACA,YAAA;AAKF;;AAHA;EACE,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;AAMF;;AAJA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;AAOF","sourcesContent":["ion-header ion-title {\n  text-align: center;\n}\nion-content{\n  --background: white;\n}\n//* OPPS --------------------------------------------------------------------- */\n.opps, .opps-brand{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 86%;\n}\n.opps-header h3{\n  margin: 20px 0;\n  text-align: center;\n  font-weight: 800;\n  font-size: x-small;\n  color: var(--ion-color-primary);\n}\nh2, h1{\n  font-weight: 600;\n  text-align: center;\n  font-size: 30px;\n  color: black;\n}\n.opps-header{\n  // box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;\n  background: white;\n  width: 90%;\n}\n.codigo{\n  width: 90%;\n  height: auto;\n}\n.iconos{\n  display: block;\n  justify-content: center;\n  align-items: center;\n  margin: auto;\n  width: 90%;\n  padding: 10px 0;\n  text-align: center;\n}\n.img-logos{\n  text-align: center;\n  width: 30%;\n  padding: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
